<template>
  <div class="fixed2" style="background-color:white;height:70px;">
    <!-- <img src="../assets/img/beibeiebei.png" alt=""> -->
    <div class="topbar" style="margin:0 auto;background-color:white;z-index:1;background-color:unset;">
      <div class="container-fluid ">
        <div class="container">
          <div class="row content" style="display: flex;">
            <div class=" logo">
              <img v-if="$WebName" src="../views/images/home/logo.png" alt="">
              <img v-if="!$WebName" src="../views/images/home/logo.jpg" alt="">
            </div>
            <div class="" style="width: 1070px;">
              <div class="row" style="width: 1055px;display: flex;align-items: center;justify-content: flex-end;">
                <el-menu :default-active="$route.path" mode="horizontal" router @select="handleSelect"
                  style="background-color:unset;">
                  <el-menu-item v-for="(item, i) in navList" :key="'n'+i" :index="item.name"
                    style="padding: 0 15px;    border-radius: 20px;">
                    {{item.navItem}}
                  </el-menu-item>
                  <el-menu-item v-for="(item, i) in navList2" :key="'i'+i" :index="item.name"
                    :route="{ path: item.name, query: { type: item.type,Name: item.shang }}"
                    style="padding: 0 15px;    border-radius: 20px;">
                    {{item.navItem}}
                  </el-menu-item>
                </el-menu>

                <div class="shoud " style="margin-left: 34%;">
                  <div class="icon visible-xs" @click="menu">
                    <span class="glyphicon glyphicon-menu-hamburger"></span>
                  </div>
                  <div class="item" :class="{'showItem':showItem,'hiddenItem':!showItem}">
                    <div v-for="(item,index) in list" :key="index" @click="itemClick(item,index)">
                      {{item.text}}
                      <!-- <div class="rec hidden-xs" v-show="item.active"><img src="../views/images/home/rec.png" alt=""></div> -->
                    </div>
                  </div>
                </div>

                <div class="">
                  <div class="search" style="margin-left: 15px;">
                    <div class="input">
                      <input type="text" placeholder="请输入关键词">
                      <img class="fdj" src="../assets/img/tuceng2.png" alt="" />
                    </div>
                    <!-- 登录后 -->
                    <el-dropdown @command="handleCommand" v-if="denglucg">
                      <div class="dengluhou">
                        <img src="../assets/img/topxiang.jpg">
                        <span>{{loginName}}</span>
                        <i class="el-icon-caret-bottom"></i>
                      </div>
                      <el-dropdown-menu slot="dropdown" class="xialadeng">
                        <el-dropdown-item command="1" v-if="userInfo.userRole != 3">基本资料</el-dropdown-item>
                        <el-dropdown-item command="2" v-if="userInfo.userRole != 3">我的分数</el-dropdown-item>
                        <el-dropdown-item command="3" v-if="userInfo.userRole == 3">我的学生</el-dropdown-item>
                        <el-dropdown-item command="7">收藏院校</el-dropdown-item>
                        <el-dropdown-item command="8">收藏专业</el-dropdown-item>
                        <el-dropdown-item command="4">我的关注 </el-dropdown-item>
                        <el-dropdown-item command="5" v-if="false">我的选科</el-dropdown-item>
                        <el-dropdown-item command="6">职业测评</el-dropdown-item>
                        <el-dropdown-item command="12" v-if="userInfo.userRole == 3">分数位次</el-dropdown-item>
                        <el-dropdown-item command="9">志愿报告单</el-dropdown-item>
                        <el-dropdown-item command="11">安全设置</el-dropdown-item>
                        <el-dropdown-item command="10">退出登录</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <!-- 登陆前 -->
                    <div class="searchBtn hidden-sm hidden-xs" @click="diandenglu(true)" v-else>登录</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 退出登录 -->
      <div class="tuichuden" v-if="duichu == true">
        <div class="annou">
          <h1>退出登录</h1>
          <p>您确定要退出登录吗？</p>
          <dl>
            <dt @click="quxiao">取消</dt>
            <dd @click="quit">确认</dd>
          </dl>
        </div>
      </div>

      <!-- 登录 -->
      <div class=" loginBody2" v-show="denglu" @click="qudiao">

      </div>
      <div class="loginAuto" v-show="denglu">
        <div class="logo"><img src="../views/images/dllogo.jpg"></div>
        <div class="loginItem">
          <ul class="loginTab flex">
            <li @click="login_type = 1" :class="{active:login_type == 1}">密码登录</li>
            <li @click="login_type = 0" :class="{active:login_type == 0}">验证码登录</li>
          </ul>
          <!-- 密码登录 -->
          <div class="loginPage" v-if="login_type == 1">
            <ul class="loginList">
              <li>
                <i class="icon">
                  <img src="../views/images/icon_01.jpg">
                </i>
                <input class="text" v-model="userName" placeholder="请输入账号" type="text" />
              </li>
              <li>
                <i class="icon">
                  <img src="../views/images/icon_02.jpg">
                </i>
                <input name="" type="password" class="text mima_dd" v-if="eyeflag" v-model="password"
                  placeholder="请输入密码">
                <input name="" type="text" class="text mima_wz" v-else v-model="password" placeholder="请输入密码">
                <a class="eyes_box " @click="eyeflag = !eyeflag"></a>
              </li>
              <li>
                <div style="display: flex; justify-content: space-between;">
                  <div><span class="error" v-if="loginerror!=''">{{loginerror}}</span></div>
                  <label><input type="checkbox" name="reading">记住我</label>
                </div>
                <button class="btn" @click="index()">登录</button>
                <div class="flex-between">
                  <a class="open" href="">新用户注册</a>
                  <a class="open" href="">忘记密码？</a>
                </div>
              </li>
            </ul>
          </div>
          <!-- 验证码登录 -->
          <div class="loginPage" v-if="login_type ==0">
            <ul class="loginList">
              <li>
                <i class="icon">
                  <img src="../views/images/icon_01.jpg">
                </i>
                <input class="text" placeholder="请输入手机号" v-model="phone" type="text" />
                <span class="error" v-if="phoneerror!=''">{{phoneerror}}</span>
              </li>
              <li>
                <i class="icon">
                  <img src="../views/images/icon_03.jpg">
                </i>
                <input class="text" placeholder="请输入验证码" v-model="text1" type="text" />
                <button class="yanzhengma">发送验证码</button>
              </li>
              <span class="error" v-if="codeerror!=''">{{codeerror}}</span>
              <li>
                <button style="margin-top: 33px;" class="btn" @click="index()">登录</button>
                <div class="flex-between">
                  <a class="open" href="">新用户注册</a>
                  <a class="open" href="">忘记密码？</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- <style scoped></style> -->
<script>
  export default {
    data() {
      return {
        userName: '',
        password: '',
        loginName: '',
        phone: '',
        text1: '',
        codeerror: '',
        phoneerror: '',
        loginerror: '',
        login_type: 1,
        eyeflag: true,
        // 是否登录
        denglucg: false,
        // 退出登录
        duichu: false,
        // 登录
        denglu: false,
        path: '',
        // 志愿填报二级
        erjie: false,
        activeIndex: "1",
        activeIndex2: "1",
        active: 1,
        navList: [{
            name: "/home",
            navItem: "网站首页",
            shang: 1,
          },
          {
            name: "/zyf",
            navItem: "院校资源",
            shang: 2,
          },
          {
            // name: {"/zhuanyezhiyuan":"/zyxq_zhuanyejieshao"},
            name: "/zhuanyezhiyuan",
            name2: "/zyxq_zhuanyejieshao",
            navItem: "专业资源",
            shang: 3,
          },
          {
            name: "/xuanzheyuanhuoye",
            // name: "/tiaobaozhiyuan",
            navItem: "志愿填报",
            shang: 4,
          },
        ],
        navList2: [{
            name: "/newListgkzx",
            navItem: "高考资讯",
            shang: 5,
            type: 'gkzx',
          },
          {
            name: "/newListksbd",
            navItem: "考生必读",
            shang: 6,
            type: 'ksbd',
          },
          {
            name: "/newListyszs",
            navItem: "艺术招生",
            shang: 7,
            type: 'yszs',
          },
          // {
          //   name: "/Vip",
          //   navItem: "成为VIP",
          //   shang: 8,
          // },
        ],
        showItem: false,
        list: [{
            text: "网站首页",
            active: false,
          },
          {
            text: "院校资源",
            active: false,
          },
          {
            text: "专业资源",
            active: false,
          },
          {
            text: "志愿填报",
            active: false,
          },
          {
            text: "高考资讯",
            active: false,
          },
          {
            text: "考生必读",
            active: false,
          },
          {
            text: "艺术招生",
            active: false,
          },
          // {
          //   text: "成为VIP",
          //   active: false,
          // },
        ]
      };
    },
    props: {
      inputName: Number,
      required: true
    },
    created() {
      this.userInfo = this.$utils.getlocalStorage('userInfo')
      if (this.userInfo != null && this.userInfo != '') {
        if (this.userInfo.userRole == '3' || this.userInfo.userRole == '2') {
          this.loginName = this.$utils.getlocalStorage('memberInfo').cardType == 3 ? "高报师" : "教师";
        } else {
          this.loginName = this.userInfo.userName;
        }
        this.denglucg = true
      }
      this.path = this.$route.path
    },

    methods: {
      index() {
        let _this = this;
        let obj = {}
        if (this.login_type == 1) {
          if (_this.userName == null || _this.userName == '' || _this.password == null || _this.password == '') {
            this.loginerror = "请填写登录信息";
            return;
          }
        } else {
          if (!this.$utils.regphone(this.phone)) {
            this.phoneerror = '请输入正确的手机号'
            return;
          }
          if (_this.text1 == null || _this.text1 == '') {
            this.codeerror = '请输入动态验证码'
            return;
          }
        }
        if (this.login_type == 0) {
          obj = {
            userPhone: this.phone,
            code: this.text1
          }
        } else {
          obj = {
            loginName: _this.userName,
            loginPwd: _this.password,
          }
        }

        this.$user.login(obj).then(function(response) {
          if (response.data != null) {
            _this.$utils.removelocalStorage("userToken");
            localStorage.setItem('userToken', response.data)
            _this.$req.getUserInfo({}).then(function(resp) {
              //删除历史数据
			  _this.$utils.removelocalStorage("userZhiYuanBatch")
              _this.$utils.removelocalStorage("memberInfo")
              _this.$utils.removelocalStorage("userInfo")
              _this.$utils.removelocalStorage("scoreInfo")
              _this.$utils.removelocalStorage("userCang")
              _this.$utils.removelocalStorage("userGuan")
              _this.$utils.removelocalStorage("areaInfo")
              _this.$utils.removelocalStorage("TianbaoQueryKey")


              _this.denglucg = true;
              _this.denglu = false;
              _this.userInfo = resp.data.userTable;
              _this.loginName = _this.userInfo.userName;
              _this.$utils.setlocalStorage('userDate', {
                loginName: _this.userName,
                loginPwd: _this.password
              })
              _this.$utils.setlocalStorage('userInfo', resp.data.userTable)
              _this.$utils.setlocalStorage('memberInfo', resp.data.memberTable)
              if (resp.data.userTable.userPhone == null) {
                _this.$router.push('/gerenzhongxin')
              } else {
                if (resp.data.userTable.userName == null || resp.data.userTable.userName == '') {
                  _this.$router.push('/gerenzhongxin')
                } else {
                  let xuankeArea = _this.$utils.getlocalStorage('xuankeArea')
                  let areaId = parseInt(resp.data.userTable.userProvinces)
                  if (resp.data.userScore) {
                    areaId = parseInt(resp.data.userScore.scoreArea)
                  }
                  let area = _this.$utils.getlocalStorage('AREA_OBJ')[areaId]
                  if (xuankeArea.xingaokao.indexOf(area) == -1) {
                    _this.$utils.setlocalStorage('tianbaoType', 0) //老高考
                  } else if (xuankeArea.xingaokao2.indexOf(area) != -1 || xuankeArea.xingaokao3.indexOf(area) !=
                    -1) {
                    _this.$utils.setlocalStorage('tianbaoType', 2) //专业组
                  } else {
                    _this.$utils.setlocalStorage('tianbaoType', 1) //单专业
                  }
                  _this.$utils.setlocalStorage('areaInfo', {
                    areaId: areaId,
                    areaName: area,
                    areaFullName: _this.$utils.getAreaFullName(areaId)
                  })
                  let cang = {
                    major: resp.data.major,
                    college: resp.data.college,
                    collegescore: resp.data.collegescore,
                    majorscore: resp.data.majorscore
                  }
                  if (resp.data.major == null) {
                    cang.major = []
                  }
                  if (resp.data.college == null) {
                    cang.college = []
                  }
                  if (resp.data.collegescore == null) {
                    cang.collegescore = []
                  }
                  if (resp.data.majorscore == null) {
                    cang.majorscore = []
                  }
                  _this.$utils.setlocalStorage('userCang', cang)
                  _this.$utils.setlocalStorage('zydnum', resp.data.zydNum)
                  if (resp.data.userScore) {
                    resp.data.userScore.score += ""
                    _this.$utils.setlocalStorage('scoreInfo', resp.data.userScore)

                  } else {
                    _this.$router.push('/grzx_wdfs')
                  }
                }
              }
            })
          } else {
            _this.$showToast({
              title: response.message,
              icon: "none"
            });
          }
        }).catch(function(error) {
          //这里只会在接口是失败状态返回，不需要去处理错误提示
          console.log(error);
        });
      },
      zhuanyeskdn() {
        this.$router.push('/tiaobaozhiyuan')
      },
      // 取消退出
      quxiao() {
        this.duichu = false
      },
      //退出
      quit() {

        let _this = this;
		_this.$utils.removelocalStorage("userZhiYuanBatch")
        this.$utils.removelocalStorage("userToken")
        this.$utils.removelocalStorage("memberInfo")
        this.$utils.removelocalStorage("scoreInfo")
        this.$utils.removelocalStorage("userInfo")
        this.$utils.removelocalStorage("userCang")
        this.$utils.removelocalStorage("userGuan")
        this.$utils.removelocalStorage("areaInfo")
        this.$utils.removelocalStorage("TianbaoQueryKey")


        this.$utils.removelocalStorage("ZhiYuancyc");
        this.$utils.removelocalStorage("ZhiYuanbyb");
        this.$utils.removelocalStorage("ZhiYuanwyw");
        this.$utils.removelocalStorage("ZhiYuandyd");
        this.$utils.removelocalStorage("ZhiYuandyd");

        this.$req.signOut({}).then(function(response) {
          if (_this.path == '/home' || _this.path == '/' || _this.path == '') {
            _this.$emit("reloadAll")
          } else {
            _this.$router.push('/home')
          }
        }).catch(function() {
          console.log(1111)
          if (_this.path == '/home') {
            _this.$emit("reloadAll")
          } else {
            _this.$router.push('/home')
          }
        })
      },
      handleSelect(key, keyPath) {
        if (keyPath == "") {
          this.erjie = true
        }
      },
      // 移入
      mouseOver1(i) {
        // console.log('12',i)
        if (i == 3) {
          this.erjie = true
        } else {
          this.erjie = false
        }
      },
      // 移除
      mouseLeave() {
        this.erjie = false
      },
      diandenglu(obg) {
        // this.$emit('func', obg)
        // this.denglu = true
        this.$router.push('/login')
        console.log(this.denglu)
      },
      qudiao() {
        this.denglu = false
      },
      tiaozhuan(shang) {
        this.active = shang
      },
      handleCommand(command) {
        // this.$message('click on item ' + command);

        let _this = this;
        console.log(command)
        switch (command) {
          case '1':
            _this.$router.push('/gerenzhongxin');
            break;
          case '2':
            _this.$router.push('/grzx_wdfs');
            break;
          case "3":
            _this.$router.push('/grzx_wdxs');
            break;
          case '4':
            _this.$router.push('/grzx_wodeguanzhu');
            break;
          case '5':
            _this.$router.push('/grzx_wodexuanke');
            break;
          case "6":
            _this.$router.push('/grzx_xinggeceping');
            break;
          case "7":
            _this.$router.push('/grzx_shouchangxueyuan');
            break;
          case "8":
            _this.$router.push('/grzx_chouchangzhuanye');
            break;
          case "9":
            _this.$utils.removelocalStorage("zyd_selectId")
            _this.$router.push('/grzx_wodezhiyuan');
            break;
          case "10":
            this.duichu = true;
            break;
          case "11":
            _this.$router.push('/grzx_xougaimima');
            break;
          case "12":
            _this.$router.push('/grzx_scorerank');
            break;
          default:
            break;
        }
      },

      tuizhu() {
        this.duichu = true
      },
      menu() {
        if (!this.showItem) {
          this.showItem = true;
          var body = document.querySelector("body");
          body.style.overflow = "hidden"
        } else if (this.showItem) {
          this.showItem = false;
          var body = document.querySelector("body");
          body.style.overflow = ""
        }
      },
      itemClick(item, index) {
        this.showItem = false;
        this.list.forEach((item) => {
          item.active = false
        });
        item.active = true;
        if (index == 0) {
          this.$router.push('/home')
        }
        if (index == 1) {
          this.$router.push('/zyf')
        }
        if (index == 2) {
          this.$router.push('/zhuanyezhiyuan')
        }
        if (index == 3) {
          this.$router.push('/tiaobaozhiyuan')
        }
        if (index == 4) {
          this.$router.push('/gaokaozhixun')
        }
        if (index == 5) {
          this.$router.push('/kaoshengbidu')
        }
        if (index == 6) {
          this.$router.push('/yishuzhaosheng')
        }
        if (index == 7) {
          this.$router.push('/Vip')
        }
      },
      getcode() {
        let _this = this;
        if (!this.$utils.regphone(this.phone)) {
          _this.phoneerror = '请输入正确的手机号'
          return;
        }
        this.$req.sendphonecodelogin({
          phone: this.phone
        }).then(function(response) {
          _this.text1 = response.data
          // _this.$showToast({
          //   title: response.message,
          //   icon: "none"
          // });
        })
      },

    },
    mounted() {
      var isAnimated = false
      let _this = this;
      this.active = this.inputName
      // this.duichu = true
      // 登录
      var times = 60;

      function roof() {
        if (times == 0) {
          $('.yanzhengma').text('发送验证码(' + times + 's)');
          $('.yanzhengma').prop('disabled', false);
          $('.yanzhengma').text('发送验证码');
          times = 10;
          return
        }
        $('.yanzhengma').text('重新发送(' + times + 's)');
        times--;

        setTimeout(roof, 1000);
      }
      $('.yanzhengma').on('click', function() {
        _this.getcode();
        $(this).prop('disabled', true);
        roof();

      });
    },
  };
</script>

<style scoped>
  .btn:focus,
  .btn:active:focus,
  .btn.active:focus,
  .btn.focus,
  .btn:active.focus,
  .btn.active.focus {
    outline: 0px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }

  /* 退出登录 */
  .tuichuden {
    z-index: 9;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgb(0 0 0 / 21%);
  }

  .annou {
    display: flex;
    flex-direction: column;
    width: 380px;
    height: 229px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 0 21px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: rgb(235 232 230);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 2px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    margin-left: 20px;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .erjikuang2 {
    height: 200px;
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    position: absolute;
    left: 345px;
    top: 0px;
  }

  .erjikuang {
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 9999;
    border-radius: 8px;
    width: 100px;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 16%);
  }

  .erjikuang li {
    width: 100%;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
  }

  .erjikuang i {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .erjikuang li:hover {
    background: rgba(200, 200, 200, 1);
    cursor: pointer;
  }


  /* 登陆后 */
  .dengluhou {
    margin-left: 14px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-shrink: 0;
    cursor: pointer;
  }

  .dengluhou img {
    height: 39px;
    width: 39px;
    border-radius: 50%;
  }

  .dengluhou span {
    font-size: 15px;
    font-family: MicrosoftYaHei;
    color: #333333;
    margin: 0 5px;
    flex-shrink: 0;
  }

  .dengluhou i {
    font-size: 14px;
    color: #29A7E1;
    flex-shrink: 0;
  }

  .xialadeng {
    width: 190px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .el-dropdown-menu__item {
    width: 100%;
    text-align: center;
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    border: none !important;
    background-color: #F53824 !important;
    color: #FFFFFF;
  }

  .el-dropdown {
    margin-left: 14px;
  }


  .el-dropdown-link {
    cursor: pointer;
    color: #FFFFFF;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .loginBody2 {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    z-index: 99;
  }

  .loginAuto {
    height: 500px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
  }

  .container {
    width: 1280px;
  }

  .sdsd {
    width: 32px;
    height: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sdsd img {
    width: 32px;
    height: 7px;
  }

  .denglu button {
    color: white;
    width: 89px;
    height: 40px;
    background: linear-gradient(0deg, #f20e23, #f75d29);
    border-radius: 19px;
    border: none !important;

  }

  .header-right {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header-right .search1 {
    margin-right: 12px;
    position: relative;
  }

  .header-right .search1 input {
    width: 209px;
    height: 40px;
    border: 1px solid #dedede;
    border-radius: 19px;
    padding-left: 15px;
    box-sizing: border-box;
  }

  ::-webkit-input-placeholder {
    color: #CAC9C9;
  }

  .header-center {
    display: flex;
    align-items: center;
  }

  .fdj {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 15px;
  }

  .header-left {
    display: flex;
    align-items: center;
  }

  .header-left img {
    width: 235px;
    height: 67px;
  }

  .header {
    height: 100px;
    display: flex;
    justify-content: space-between;
  }

  .el-menu.el-menu--horizontal {
    border: none !important;
  }

  .el-menu.el-menu--horizontal li {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 35px;
    line-height: 35px;
    color: #303133;
  }


  .el-menu-item {
    font-size: 18px !important;
  }






  .topbar {
    height: 88px;
  }

  .topbar .content {
    margin: 0px auto;
  }

  .topbar .content .logo {
    display: flex;
    height: 88px;
    justify-content: center;
    align-items: center;
  }

  .topbar .content .logo>img {
    width: 100%;
    height: 35px;
  }

  .topbar .content .item {
    display: block;
    overflow: hidden;
    height: 70px;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 99;
    background-color: #fff;
    width: 100%;
    height: 100%;
    left: -100%;
    top: 88px;
    padding: 25px;
    box-sizing: border-box;
    transition: 0s;
  }

  .topbar .content .item>div {
    cursor: pointer;
    font-size: 12px;
    height: 45px;
    font-size: 20px;
    text-indent: 25px;
    color: #333333;
  }

  .topbar .content .showItem {
    display: block;
    width: 100%;
    left: 0px;
    transition: 0.3s left;
  }

  .topbar .content .hiddenItem {
    display: block;
    width: 100%;
    left: -100%;
    transition: 0.5s left;
  }

  .topbar .content .icon {
    height: 88px;
    color: #333;
  }

  .topbar .content .icon>span {
    line-height: 88px;
    color: #333;
    cursor: pointer;
    font-size: 22px;
  }

  .topbar .content .icon:hover~.item {}

  .topbar .content .search {
    width: 100%;
    height: 88px;
    align-items: center;
    display: flex;
  }

  .topbar .content .search>.input {
    width: 100%;
    height: 35px;
    position: relative;
  }

  .topbar .content .search>.input>input {
    width: 100%;
    height: 35px;
    outline: none;
    border: 1px solid #DEDEDE;
    border-radius: 20px;
    padding: 0px 18px;
    font-size: 16px;
    box-sizing: border-box;
  }

  .topbar .content .search>.searchBtn {
    flex-grow: 1;
    width: 1px;
    height: 35px;
    border-radius: 17.5px;
    line-height: 35px;
    text-align: center;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    margin-left: 5px;
    color: #fff;
    font-size: 12px;
  }


  .shoud {
    display: none;
  }

  .topbar {
    height: 70px;
  }

  .topbar .content {
    margin: 0px auto;
  }

  .topbar .content .logo {
    display: flex;
    height: 70px;
    justify-content: center;
    align-items: center;
  }

  .topbar .content .logo>img {
    width: 100%;
    height: 35px;
  }

  .topbar .content .item {
    display: flex;
    width: 100%;
    height: 70px;
    justify-content: center;
    align-items: center;
    position: inherit;
    top: 0px;
    left: 0px;
    padding: 0px;
    transition: 0s;
  }

  .topbar .content .item>div {
    cursor: pointer;
    font-size: 12px;
    line-height: 0px;
    height: 100%;
    line-height: 70px;
    text-align: left;
    flex-grow: 1;
    text-align: center;
    text-indent: 0px;
    position: relative;

  }

  .topbar .content .item>div>.rec {
    position: absolute;
    top: auto;
    width: 32px;
    height: 7px;
    left: 0px;
    right: 0px;
    margin: 0px auto;
    bottom: 70px;
  }

  .topbar .content .search {
    width: 100%;
    height: 70px;
    margin-left: 15px;
    align-items: center;
    display: flex;
    padding: 0px;
  }

  .topbar .content .search>.input {
    width: 115px;
    height: 35px;
    position: relative;
  }

  .topbar .content .search>.input>input {
    width: 100px;
    height: 35px;
    outline: none;
    border: 1px solid #DEDEDE;
    box-sizing: border-box;
    border-radius: 20px;
    padding: 0px 10px;
    font-size: 16px;
  }

  .topbar .content .search>.searchBtn {
    cursor: pointer;
    flex-grow: 1;
    width: 1px;
    height: 35px;
    border-radius: 17.5px;
    line-height: 35px;
    text-align: center;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    margin-left: 5px;
    color: #fff;
    font-size: 12px;
  }



  .topbar {
    height: 70px;

  }

  .topbar .content {
    margin: 0px auto;
  }

  .topbar .content .logo {
    display: flex;
    height: 70px;
    width: 250px;
    padding-left: 0px;
    padding-right: 40px;
    justify-content: center;
    align-items: center;
  }

  .topbar .content .logo>img {
    width: 100%;
    height: 50px;
  }

  .topbar .content .item {
    display: flex;
    width: 100%;
    height: 70px;
    justify-content: center;
    align-items: center;
  }

  .topbar .content .item>div {
    cursor: pointer;
    height: 100%;
    line-height: 70px;
    text-indent: 0px;
    flex-grow: 1;
    text-align: center;
    position: relative;
  }

  .topbar .content .item>div>.rec {
    position: absolute;
    top: auto;
    width: 32px;
    height: 7px;
    left: 0px;
    right: 0px;
    margin: 0px auto;
    bottom: 70px;
  }

  .topbar .content .search {
    width: 100%;
    height: 70px;
    align-items: center;
    display: flex;
  }

  .topbar .content .search>.input {
    width: 155px;
    height: 40px;
    position: relative;
  }

  .topbar .content .search>.input img {
    height: 18px;
    width: 18px;
    position: absolute;
    top: 10px;
    right: 15px;
  }

  .topbar .content .search>.input>input {
    width: 155px;
    height: 40px;
    outline: none;
    border: 1px solid #DEDEDE;
    box-sizing: border-box;
    border-radius: 20px;
    padding: 0px 18px;
    font-size: 16px;

  }

  .topbar .content .search>.searchBtn {
    flex-grow: 1;
    height: 35px;
    width: 100px;
    border-radius: 20px;
    line-height: 35px;
    text-align: center;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    margin-left: 5px;
    color: #fff;
  }






  .el-menu {
    background-color: #f20e23;
  }

  /*固定定位*/
  .nav {
    width: 100%;
    position: relative;
    height: 100px;
  }

  /* .classifi{
	padding-top: 100px;
} */
  .fixed222 {
    position: fixed;
    top: -40px;
    z-index: 99;
    background-color: white;
    width: 100%;
    height: 100px;
    margin-top: 30px;
  }

  .fixed2 {
    position: fixed;
    z-index: 100;
    top: 0;
    width: 100%;
    border-bottom: 1px solid #CAC9C9;
  }


  .el-menu--horizontal>.el-menu-item.is-active {
    background-color: #e63233;
    color: #FFFFFF;
    border-radius: 20px;
    border-bottom: none;
  }

  .el-menu--horizontal>.el-menu-item.is-active:hover {
    background-color: #e63233;
    color: #FFFFFF;
    border-radius: 20px;
  }

  .el-menu,
  .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus {
    background-color: #e63233;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/vHeader.vue